import React, { useEffect, useState } from "react";
import apiServer from "../../constants/apiServer";
import useFetchInfo from "../../utils/useFetchInfo";
import { img_url_api } from "../../constants/apiImg";
import "../../css/process.sass";
import "../../css/artist.sass";
import { checkFormValidate } from "../../utils/commonFuncs";
import PopupLoading from "../../common/PopupLoading";
import { format } from "date-fns";
import { put } from "../../utils/api";
// import { stringify } from "query-string";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../common/Loading";
import EmptyPage from "../../common/EmptyPage";
import ProcessForm from "./ProcessForm";

const UpdateProcess = () => {
    const [processInfoValues, setProcessInfoValues] = useState({
        nameEng: "",
        nameMyan: "",
        step: null,
        chosenProduct: null,
        startDate: new Date(),
        endDate: new Date(),
        desEng: "",
        desMyan: "",
        youtubeLink: "",
        chosenArtistList: [],
        imageList: [],
        deleteImageList: [],
    });

    const { processId } = useParams();

    const navigate = useNavigate();

    const [activeStep, setActiveStep] = useState(0);

    const [errorValueList, setErrorValueList] = useState({});

    const [updateLoading, setUpdateLoading] = useState(false);
    const [errorUpdate, setErrorUpdate] = useState("");

    const [getInfoLoading, setGetInfoLoading] = useState(false);
    const [getInfoError, setGetInfoError] = useState("");

    const { data, isLoading, error } = useFetchInfo(
        `${apiServer.process.detail}/${processId}`
    );

    useEffect(() => {
        if (!data) return;

        // Parse JSON strings if needed
        const parseSafely = (data) => {
            if (typeof data !== 'string') return data;
            try {
                return JSON.parse(data);
            } catch (e) {
                return data;
            }
        };

        const titleData = parseSafely(data?.title);
        const descriptionData = parseSafely(data?.description);

        const startDate = data?.from_date ? new Date(data.from_date) : new Date();
        const endDate = data?.to_date ? new Date(data.to_date) : new Date();

        const product = data?.product;
        const productName = product?.name;
        const productId = product?.id;

        const receivedArtistList = [];
        const processArtists = data?.process_artists || [];
        for (let i = 0; i < processArtists?.length; i++) {
            const artist = processArtists[i]?.artist;
            if (artist) {
                const artistName = artist?.name?.eng || artist?.name?.mm || artist?.name;
                receivedArtistList.push({
                    profile: artist?.image ? img_url_api + artist.image : null,
                    name: artistName,
                    id: artist?.id,
                });
            }
        }

        const receivedMediaList = [];
        const processMediaList = data?.process_media || [];
        for (let i = 0; i < processMediaList?.length; i++) {
            const media = processMediaList[i];
            const fileExtension = media?.file?.split('.').pop()?.toLowerCase();
            const isVideo = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'].includes(fileExtension);
            
            receivedMediaList.push({
                id: media?.id,
                src: img_url_api + media?.file,
                file: img_url_api + media?.file,
                type: isVideo ? `video/${fileExtension}` : `image/${fileExtension}`,
                caption: media?.caption,
                status: "uploaded",
            });
        }

        setProcessInfoValues({
            nameEng: titleData?.en || "",
            nameMyan: titleData?.mm || "",
            step: { label: `Step ${data?.step_name}`, value: data?.step_name },
            chosenProduct: {
                label: `${productName?.en || ""} : ${productName?.mm || ""}`,
                value: productId,
            },
            startDate: startDate,
            endDate: endDate,
            desEng: descriptionData?.en || "",
            desMyan: descriptionData?.mm || "",
            youtubeLink: data?.youtube_link || "",
            chosenArtistList: receivedArtistList,
            imageList: receivedMediaList,
            deleteImageList: [],
        });

        setGetInfoLoading(isLoading);
        setGetInfoError(error);
    }, [data, isLoading, error]);

    const handleChooseValue = (name, selectedOption) => {
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                [name]: selectedOption,
            };
        });
        delete errorValueList[name];
        setErrorValueList(errorValueList);
    };

    const handleAddValues = (name, valueInfo) => {
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                [name]: [...prevInfo[name], valueInfo],
            };
        });
    };

    const handleRemoveValues = (name, valueInfo) => {
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                [name]: prevInfo[name].filter(
                    (element) => parseInt(element.id) !== parseInt(valueInfo.id)
                ),
            };
        });
    };

    const handleChangeCaption = (value, imageInfo) => {
        const modifiedImageList = processInfoValues["imageList"];
        let modifiedImageId = modifiedImageList.findIndex(
            (element) => element.id === imageInfo.id
        );
        modifiedImageList[modifiedImageId]["caption"] = value;
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                imageList: modifiedImageList,
            };
        });
    };

    const handleInput = (event) => {
        const { name, value } = event.target;
        console.log("input values::", name, value);
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                [name]: value,
            };
        });
        delete errorValueList[name];
        setErrorValueList(errorValueList);
    };

    const handleUploadImg = (imgInfo) => {
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                imageList: [...prevInfo["imageList"], imgInfo],
            };
        });
    };

    const handleChangeStartDate = (event) => {
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                startDate: event,
                endDate: event,
            };
        });
    };

    const handleChangeEndDate = (event) => {
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                endDate: event,
            };
        });
    };

    const handleRemoveImage = (imageInfo) => {
        setProcessInfoValues((prevInfo) => {
            return {
                ...prevInfo,
                imageList: processInfoValues["imageList"].filter(
                    (element) => element !== imageInfo
                ),
                deleteImageList: [...prevInfo["deleteImageList"], imageInfo],
            };
        });
    };

    const handleNext = () => {
        if (activeStep === 0) {
            const generalInfoValue = {
                nameEng: processInfoValues["nameEng"],
                nameMyan: processInfoValues["nameMyan"],
                step: processInfoValues["step"],
                chosenProduct: processInfoValues["chosenProduct"],
            };
            const checkGeneralInfo = checkFormValidate(generalInfoValue);
            setErrorValueList(checkGeneralInfo);
            const errorStateList = Object.keys(checkGeneralInfo);
            if (errorStateList.length === 0) {
                setActiveStep((prevStep) => prevStep + 1);
            }
        } else if (activeStep === 1) {
            const detailedInfoValue = {
                startDate: processInfoValues["startDate"],
                endDate: processInfoValues["endDate"],
                desEng: processInfoValues["desEng"],
                desMyan: processInfoValues["desMyan"],
                chosenArtistList: processInfoValues["chosenArtistList"],
            };
            const checkDetailedInfo = checkFormValidate(detailedInfoValue);
            setErrorValueList(checkDetailedInfo);
            const detailErrorList = Object.keys(checkDetailedInfo);
            if (detailErrorList.length === 0) {
                setActiveStep((prevStep) => prevStep + 1);
            }
        } else if (activeStep === 2) {
            handleUpdate();
        }
    };

    const handleUpdate = async () => {
        const {
            nameEng, nameMyan, step, chosenProduct,
            startDate, endDate, desEng, desMyan, youtubeLink,
            imageList, deleteImageList, chosenArtistList,
        } = processInfoValues;

        setUpdateLoading(true);
        const passedBody = new FormData();
        
        passedBody.append("title", JSON.stringify({ en: nameEng || "", mm: nameMyan || "" }));
        passedBody.append("description", JSON.stringify({ en: desEng || "", mm: desMyan || "" }));
        passedBody.append("youtube_link", youtubeLink || "");
        
        passedBody.append("step_name", step || "");
        passedBody.append("product_id", chosenProduct?.value || "");
        passedBody.append("from_date", startDate ? format(startDate, "yyyy-MM-dd") : "");
        passedBody.append("to_date", endDate ? format(endDate, "yyyy-MM-dd") : "");

        
        if (chosenArtistList && chosenArtistList.length > 0) {
            chosenArtistList.forEach(artist => {
                if (artist.id) passedBody.append("artist_ids", artist.id);
            });
        }

       
        imageList.forEach((img) => {
            if (img.status !== "uploaded" && img.file instanceof File) {
                passedBody.append("media_files", img.file);
                passedBody.append("captions", img.caption || ""); 
            }
        });

        // ✅ Delete Media IDs
        if (deleteImageList && deleteImageList.length > 0) {
            deleteImageList.forEach(img => {
                if (img.id) passedBody.append("delete_media_ids", img.id);
            });
        }

        try {
            const response = await put(`${apiServer.process.update}/${processId}`, passedBody);
            setUpdateLoading(false);
            if (response.data.success) {
                navigate("/processes", { replace: true, state: { status: "success", message: response.data.message } });
            } else {
                setErrorUpdate(response.data.message || "Update failed");
            }
        } catch (error) {
            setUpdateLoading(false);
            setErrorUpdate(error.response?.data?.message || error.message);
        }
    };

    const handleBack = () => {
        setActiveStep((prevStep) => (prevStep <= 0 ? 0 : prevStep - 1));
    };

    if (getInfoLoading) return <Loading text="Retrieving Information" />;

    if (getInfoError) return <EmptyPage text={getInfoError} />;

    if (updateLoading) return <PopupLoading text="Updating Process" />;

    return (
        <ProcessForm
            title="Update"
            processInfoValues={processInfoValues}
            handleInput={handleInput}
            errorValueList={errorValueList}
            onUploadImg={handleUploadImg}
            handleChangeStartDate={handleChangeStartDate}
            handleChangeEndDate={handleChangeEndDate}
            handleChooseValue={handleChooseValue}
            handleAddValues={handleAddValues}
            handleRemoveValues={handleRemoveValues}
            onRemoveImage={handleRemoveImage}
            onChangeCaption={handleChangeCaption}
            activeStep={activeStep}
            handleNext={handleNext}
            handleBack={handleBack}
            errorMessage={errorUpdate}
        />
    );
};

export default UpdateProcess;
